(function(root, factory) {
  const api = factory();

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  }

  if (root) {
    root.WallForgeArtworkProfile = api;
  }
})(typeof window !== 'undefined' ? window : globalThis, function() {
  'use strict';

  const POLICY_CONTRACT = 'wallforge.product-aspect-ratio-policy@v1';
  const ARTWORK_PROFILE_CONTRACT = 'wallforge.customer-artwork-profile@v1';
  const SELECTOR = 'nearest_log_ratio_v1';

  function parseObject(value) {
    if (value && typeof value === 'object' && !Array.isArray(value)) return value;
    if (typeof value !== 'string' || value.trim() === '') return null;

    try {
      const parsed = JSON.parse(value);
      return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : null;
    } catch (_error) {
      return null;
    }
  }

  function parsePolicy(value, declaredDynamic) {
    const policy = parseObject(value);
    const requiresDynamic = Boolean(declaredDynamic || policy?.mode === 'match_source');
    const allowed = policy?.allowedAspectRatios;
    const valid = Boolean(
      policy
      && policy.contract === POLICY_CONTRACT
      && policy.mode === 'match_source'
      && policy.selector === SELECTOR
      && Array.isArray(allowed)
      && allowed.length === 2
      && allowed[0] === '3:4'
      && allowed[1] === '4:3'
      && ['3:4', '4:3'].includes(policy.fallbackAspectRatio)
    );

    return { policy, requiresDynamic, valid: !requiresDynamic || valid };
  }

  function normalizeVariantIds(values) {
    if (!Array.isArray(values)) return [];

    return Array.from(new Set(values
      .map((value) => String(value || '').trim())
      .filter((value) => /^[1-9][0-9]*$/.test(value))));
  }

  function normalizeProfile(value) {
    const profile = parseObject(value);
    const allowedVariantIds = normalizeVariantIds(profile?.allowedVariantIds);

    if (!profile
      || profile.contract !== ARTWORK_PROFILE_CONTRACT
      || profile.selector !== SELECTOR
      || profile.accepted !== true
      || !['3:4', '4:3'].includes(profile.aspectRatio)
      || !['print_3_4', 'print_4_3'].includes(profile.outputProfile)
      || allowedVariantIds.length === 0) {
      return null;
    }
    if ((profile.aspectRatio === '3:4') !== (profile.outputProfile === 'print_3_4')) return null;
    if (profile.orientation !== (profile.aspectRatio === '3:4' ? 'portrait' : 'landscape')) return null;

    return { ...profile, allowedVariantIds };
  }

  function allowedVariants(variants, allowedVariantIds) {
    if (!Array.isArray(variants)) return [];
    const ids = normalizeVariantIds(allowedVariantIds);
    if (ids.length === 0) return [];
    const allowed = new Set(ids);

    return variants.filter((variant) => allowed.has(String(variant?.id || '')));
  }

  function chooseCompatibleVariant(variants, allowedVariantIds, currentVariantId, currentOptions) {
    const allowed = allowedVariants(variants, allowedVariantIds);
    if (allowed.length === 0) return null;
    const currentId = String(currentVariantId || '');
    const selected = allowed.find((variant) => String(variant.id) === currentId);
    if (selected) return selected;

    const options = Array.isArray(currentOptions) ? currentOptions : [];
    return allowed
      .map((variant, index) => ({
        variant,
        index,
        matches: (variant.options || []).filter((value, optionIndex) => value === options[optionIndex]).length,
      }))
      .sort((left, right) => right.matches - left.matches || left.index - right.index)[0].variant;
  }

  return {
    POLICY_CONTRACT,
    ARTWORK_PROFILE_CONTRACT,
    SELECTOR,
    parsePolicy,
    normalizeVariantIds,
    normalizeProfile,
    allowedVariants,
    chooseCompatibleVariant,
  };
});
